
import Vue from "vue";
import CrmHistory from "@/models/crm/crm-history";
import CrmHistoryCall from "@/models/crm/crm-history-call";

export default Vue.extend({
	data() {
		return {
			props: new CrmHistoryCall(),
			text: ""
		};
	},
	props: {
		value: {
			required: true,
			type: Object as () => CrmHistory
		},
	},
	computed: {
		title: {
			get(): string {
				return (this.value.Props as any).Title || "";
			},
			set(value: string){
				(this.value.Props as any).Title = value;
				this.$emit("input", this.value);
			}
		}
	},
	watch: {
		value: {
			immediate: true,
			handler() {
				this.text = (this.value.Props as any).Message;
			}
		}
	},
	methods: {
		onInput(value: string){
			let regex = /style="(.*?)"/gm;
			value = value.replace(regex, "");
			this.text = value;
			(this.value.Props as any).Message = value;
			this.$emit("input",this.value);
		},
		focusEditor(){
			let editor = this.$refs.editor as any;
			if (!editor) return;
			let el = editor.$refs.mainEl as HTMLElement;
			if (el) el.focus();
		},
	},
	i18nEx: {
		componentPrefix: "components.crm"
	}
});
